import React from "react";
import AddPlantCard from "./addplantCard";
import CreditCard from "./creditcard";
import { IoIosAddCircleOutline } from "react-icons/io";
import "./index.css";
import { Row, Col, Button } from "antd";
import { BsChevronLeft } from "react-icons/bs";
import { BsChevronRight } from "react-icons/bs";
import "./index.css";

export default function CreditCardInfo({
  inputText,
  cardIcon,
  cards,
  isOpenCard
}) {
  return (
    <Row justify="center" style={{ padding: "2rem 0rem" }} gutter={[0, 10]}>
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <h3 className="text-left" style={{ padding: "10px" }}>
          Credit Card Information
        </h3>
        <Row justify="start" style={{ padding: "1rem" }} gutter={[0, 10]}>
          <Col xs={24} sm={24} md={12} lg={8} xl={8} className="custom">
            <AddPlantCard
              cardIcon={<IoIosAddCircleOutline size={50} />}
              cardText="Add new Card"
              className="ant-card-body"
              cardStyle={{ height: "200px" }}
              onChangePlantModal={isOpenCard}
            />
          </Col>
          {cards.map((item) => {
            return (
              <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                <CreditCard
                  tickIcon={true}
                  dotsIcon={true}
                  data={item}
                  cardStyle={{ height: "200px" }}
                />
              </Col>
            );
          })}
        </Row>
        <Col xs={24} sm={24} md={23} lg={23} xl={23}>
          <Row
            gutter={[5, 0]}
            xs={24}
            sm={24}
            md={23}
            lg={23}
            xl={23}
            justify="start"
          >
            <Col className="tablePagination">
              {`Displaying 1 of  1`}
              {/* {`Displaying ${metaData?.currentCount} of ${metaData?.totalCount}`} */}
              <Button
                type="link"
                icon={<BsChevronLeft color="#686868" size={15} />}
                // onClick={previousPage}
                // disabled={metaData.page === 1}
              />
              {/* For  Showing Page-No */}
              {/* {metaData?.page} */}
              <Button
                type="link"
                icon={<BsChevronRight color="#686868" size={15} />}
                // onClick={currentPage}
                // disabled={metaData.total_pages === metaData.page}
              />
            </Col>
          </Row>
        </Col>
      </Col>
    </Row>
  );
}
